// CloseButton.tsx
import React from 'react';

// Use a type alias instead of an empty interface 
// to avoid the @typescript-eslint/no-empty-interface rule:
type CloseXButtonProps = React.SVGProps<SVGSVGElement>;

export function CloseXButton(props: Readonly<CloseXButtonProps>) {
  return <CloseXButtonBase fill="white" {...props} />
}

export function CloseXButtonBase(props: Readonly<CloseXButtonProps>) {
  return (
    <svg
      // Preserving original width, height, and viewBox:
      width="40"
      height="40"
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.5856 31.414C28.9756 31.804 29.4876 32 29.9996 32C30.5116 32 31.0235 31.804 31.4135 31.414C32.1955 30.632 32.1955 29.3681 31.4135 28.5861L22.8279 20.0002L31.4135 11.4144C32.1955 10.6324 32.1955 9.36847 31.4135 8.58649C30.6316 7.8045 29.3676 7.8045 28.5856 8.58649L20 17.1723L11.4144 8.58649C10.6324 7.8045 9.36844 7.8045 8.58648 8.58649C7.80451 9.36847 7.80451 10.6324 8.58648 11.4144L17.1721 20.0002L8.58648 28.5861C7.80451 29.3681 7.80451 30.632 8.58648 31.414C8.97646 31.804 9.48844 32 10.0004 32C10.5124 32 11.0244 31.804 11.4144 31.414L20 22.8282L28.5856 31.414Z"
        fill="currentColor"
      />
    </svg>
  );
}
